<div class="membership-section">
    <h2 class="section__name">{{ section.name | htmlDecode }}</h2>

    <!-- Elements Rendering -->
    <div *ngFor="let element of section.elements">
        <ng-container [ngSwitch]="categorizeElement(element)">
            <app-summary-price-field *ngSwitchCase="'priceField'" [element]="getGeneralElement(element)"></app-summary-price-field>
            <app-summary-simple-text *ngSwitchCase="'simpleText'" [element]="element"></app-summary-simple-text>
            <app-summary-address-field *ngSwitchCase="'addressField'" [element]="element"></app-summary-address-field>
            <app-summary-file-field *ngSwitchCase="'fileField'" [element]="element"></app-summary-file-field>
            <app-summary-select-field *ngSwitchCase="'selectField'" [element]="element"></app-summary-select-field>
        </ng-container>
    </div>

    <!-- Organization Rendering -->
    <ng-container *ngIf="section.organization">
        <div *ngFor="let element of section.organization.elements">
            <ng-container [ngSwitch]="categorizeElement(element)">
                <app-summary-price-field *ngSwitchCase="'priceField'" [element]="getOrganizationElement(element)"></app-summary-price-field>
                <app-summary-simple-text *ngSwitchCase="'simpleText'" [element]="element"></app-summary-simple-text>
                <app-summary-address-field *ngSwitchCase="'addressField'" [element]="element"></app-summary-address-field>
                <app-summary-file-field *ngSwitchCase="'fileField'" [element]="element"></app-summary-file-field>
                <app-summary-select-field *ngSwitchCase="'selectField'" [element]="element"></app-summary-select-field>
            </ng-container>
        </div>
    </ng-container>
    

    <!-- Applicants Rendering -->
    <div *ngFor="let applicant of section.applicants">
        <span class="applicant__title">Applicant</span>
        <div class="applicant-info-wrapper">
            <span class="applicant__name">{{ applicant.firstName }} {{ applicant.lastName }}</span>
            <div class="applicant-element-wrapper" *ngFor="let element of applicant.elements">
                <ng-container [ngSwitch]="categorizeElement(element)">
                    <app-summary-price-field *ngSwitchCase="'priceField'" [element]="getApplicantElement(applicant, element)"></app-summary-price-field>
                    <app-summary-simple-text *ngSwitchCase="'simpleText'" [element]="element"></app-summary-simple-text>
                    <app-summary-address-field *ngSwitchCase="'addressField'" [element]="element"></app-summary-address-field>
                    <app-summary-file-field *ngSwitchCase="'fileField'" [element]="element"></app-summary-file-field>
                    <app-summary-select-field *ngSwitchCase="'selectField'" [element]="element"></app-summary-select-field>
                </ng-container>
            </div>
        </div>
    </div>
</div>